import api from '../clients/axios';

const resource = 'api/v1/salesforce-accounts';

export default {
  async getAllAccounts(data) {
    const response = await api.get(`${resource}/customer/${data.customerId}`, { params: data.params });
    return response.data;
  },
  async createAccount(body) {
    const response = await api.post(`${resource}`, body.body, { params: body.params });
    return response;
  },
};
